// extracted by mini-css-extract-plugin
module.exports = {"bannerIcon":"BannerIcon_bannerIcon__fTvKc","icon":"BannerIcon_icon__tewW_","text":"BannerIcon_text__yEBRr","bannerIconSmall":"BannerIcon_bannerIconSmall__EJvta"};